import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const AnonymousRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            if (rest.exclusively && rest.isAuthenticated === true) {
                let to =
                    props.location && props.location.state && props.location.state.from && props.location.state.from.pathname
                        ? props.location.state.from.pathname
                        : '/';

                return <Redirect to={{ pathname: to, state: { from: props.location } }} />;
            }

            return <Component {...props} {...rest} />;
        }}
    />
);

export default AnonymousRoute;



// WEBPACK FOOTER //
// ./src/components/routes/anonymous.jsx